import store from "@/store";
import analytics from "./analytics";
import auth from "./auth";
import companies from "./companies";
import financing from "./financing";
import groups from "./groups";
import members from "./members";
import monthlydata from "./monthlynumbers"
import cohortAnalysis from "./cohortAnalysis";
import platformStats from "./platformStats";
import chatbot from "./chatbot";
import { UserService } from "@/storage";

// import logs from "./logs";

export default [
  {
    path: "/",
    name: "home",
    redirect: "/manage/companies",
    component: () => import("@/views/layout/default"),
    children: [
      ...companies,
      ...financing,
      ...groups,
      ...members,
      ...analytics,
      ...monthlydata,
      ...cohortAnalysis,
      ...platformStats,
      ...chatbot,
      // ...logs
    ],
    beforeEnter(to, from, next) {
      if (store.getters.authenticated || UserService.getUser()) next();
      else next({ name: "login", query: { next: to.path } });
    },
  },
  {
    path: "/",
    component: () => import("@/views/pages/auth/auth"),
    children: [...auth],
  },
  {
    path: "*",
    redirect: "/404",
  },
  {
    path: "/403",
    name: "403",
    meta: {
      title: "403",
    },
    component: () => import("@/views/pages/errors/403.vue"),
  },
  {
    path: "/404",
    name: "404",
    meta: {
      title: "404",
    },
    component: () => import("@/views/pages/errors/404.vue"),
  },
];
